import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { PrivateLayout } from '~/pages';
import SubRouteSwitch from '~/pages/Match/components/subRoute/SubRouteSwitch';
import SubRouteTabs from '~/pages/Match/components/subRoute/SubRouteTabs';
import NavigationBar from '~/components/NavigationBar';
import { theme } from '~/styles/theme';
import EmptyPage from '~/pages/EmptyPage';
import { useSelector } from 'react-redux';
import * as S from '../styles';

const Match = ({ failed }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);

  const styleTab = {
    primaryColor: theme.white,
    secondaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
    contrastColor: theme.white,
    textColor: theme.dark,
  };

  const tabs = [
    {
      section: '/information',
      icon: 'info',
      label: t('information'),
    },
    {
      section: '/global-statistics',
      icon: 'stats',
      label: t('stats'),
    },
    {
      section: '/previous',
      icon: 'previous',
      label: t('previous'),
    },
    {
      section: '/direct/minute-by-minute',
      icon: 'live',
      label: t('live'),
    },
  ];

  return (
    <PrivateLayout
      subHeader={null}
      navBar={
        location.pathname.includes('previous') && !failed ? (
          <NavigationBar mobile />
        ) : null
      }
      footer={
        !failed && <SubRouteTabs tabs={tabs} styleTab={styleTab} isMobile />
      }
    >
      {failed && <EmptyPage />}
      {!failed && (
        <S.MainContainer>
          <S.SubRouteContainerSm>
            <SubRouteSwitch />
          </S.SubRouteContainerSm>
        </S.MainContainer>
      )}
    </PrivateLayout>
  );
};

Match.propTypes = { failed: PropTypes.bool };

Match.defaultProps = { failed: false };

export default Match;
